<div class="main-content">
  <div class="logo-container">
    <img
      *ngIf="data | getVariantAssetForCard | async as variantAsset; else brandName"
      appImage
      class="brand-logo"
      [asset]="variantAsset"
      src=""
      alt="" />
    <ng-template #brandName>
      <div
        *ngIf="data | sectionRowViewModelBasicMethod: 'getBrand' as brand"
        appPrintCardScaleDownText
        [transparentWhileScaling]="viewModel.viewingInLiveView$ | async"
        [maxHeightInPx]="90"
        class="product-card-brand"
        [style.color]="viewModel.headerTextColor$ | async">
        {{ brand }}
      </div>
    </ng-template>
  </div>

  <div class="product-info-container">
    <div class="product-info">
      <div class="title-quantity-and-unit-size">
        <div
          class="product-card-title"
          [style.background-color]="viewModel.cardAccentColor$ | async"
          [style.color]="viewModel.headerTextColor$ | async">
          {{ data | sectionRowViewModelBasicMethod: 'getRowTitle' | trimSafely | uppercase }}
        </div>
        <div class="product-card-size" [style.color]="viewModel.bodyTextColor$ | async">
          <div *ngIf="viewModel.cardSize$ | async as size">
            {{ size }}
          </div>
        </div>
      </div>

      <div class="pricing-container" [style.color]="viewModel.bodyTextColor$ | async">
        <app-master-kush-strain-price></app-master-kush-strain-price>
      </div>
    </div>
    <div class="strain-info" [style.color]="viewModel.bodyTextColor$ | async">
      <div *ngFor="let variantRM of viewModel.visibleVariantVMs$ | async" class="product-card-individual-product-info">
        <app-master-kush-strain-variant
          [data]="variantRM"
          [hasAssortedSizes]="viewModel.variantsHaveAssortedSizes$ | async"></app-master-kush-strain-variant>
      </div>
      <div *ngIf="viewModel.nMoreStrains$ | async as nFlavours" class="plus-n-more-strains">+{{ nFlavours }} MORE</div>
    </div>
  </div>
</div>
